import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getOrgTermsContent } from '../../../content/utils.js';
import CustomizeStakeholderAnalysisIcon from '../../icons/CustomizeStakeholderAnalysisIcon.jsx';
import DownloadReportIcon from '../../icons/DownloadReportIcon.jsx';
import {
  ChangeStrategySettingsLink,
  EditChangeStrategyLink,
} from '../../links/index.jsx';
import { EditBlueIcon } from '../../icons/EditBlueIcon.jsx';
import { resetChangeStrategyDraftId } from '../../../modules/changeStrategy.js';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const mapDispatchToProps = {
  resetChangeStrategyDraftId,
};

const ChangeStrategyActionsDropdown = ({
  slug,
  projectId,
  onDownloadReport,
  isReportLoading,
  isChangeStrategyExist,
  project,
}) => {
  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {isChangeStrategyExist ? (
          project.archived ? (
            <span className="item">
              <MenuItem
                onClick={() =>
                  window.alert(getOrgTermsContent('archivedProjectMessage'))
                }
              >
                <span className="flex">
                  <EditBlueIcon />
                  <span>&nbsp; Edit</span>
                </span>
              </MenuItem>
              <MenuItem divider />
            </span>
          ) : (
            <EditChangeStrategyLink projectId={projectId}>
              <CustomMenuItem>
                <span className="flex">
                  <EditBlueIcon />
                  <span>&nbsp; Edit</span>
                </span>
              </CustomMenuItem>
              <CustomMenuItem divider />
            </EditChangeStrategyLink>
          )
        ) : null}

        {project.archived ? (
          <span className="item">
            <MenuItem
              onClick={() =>
                window.alert(getOrgTermsContent('archivedProjectMessage'))
              }
            >
              <span className="flex">
                <CustomizeStakeholderAnalysisIcon />
                <span className="m-l-8">&nbsp; Customize Change Strategy</span>
              </span>
            </MenuItem>
            <MenuItem divider />
          </span>
        ) : (
          <ChangeStrategySettingsLink projectId={projectId}>
            <CustomMenuItem>
              <span className="flex">
                <CustomizeStakeholderAnalysisIcon />
                <span className="m-l-8">Customize Change Strategy</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </ChangeStrategySettingsLink>
        )}

        {isChangeStrategyExist && (
          <span className="item">
            <CustomMenuItem>
              <button
                className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
                disabled={isReportLoading}
                onClick={onDownloadReport}
              >
                <DownloadReportIcon />
                &nbsp;
                <span className="m-l-8">
                  {isReportLoading ? 'Loading...' : 'Download PDF'}
                </span>
              </button>
            </CustomMenuItem>
          </span>
        )}
      </DropdownButton>
    </div>
  );
};

export default connect(null, mapDispatchToProps)(ChangeStrategyActionsDropdown);
